module.exports = __webpack_public_path__ + "static/media/tray5.53b504d2.png";